import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, output, signal, viewChild } from '@angular/core';
import { LauncherModulesFacade } from '@layout/launcher/facades/launcher-modules.facade';
import { TranslatePipe } from '@ngx-translate/core';
import { LauncherItemComponent } from '@layout/launcher/components/launcher-item/launcher-item.component';
import { SpinnerComponent } from '@kaseya-design-components';
import { ThemedImageComponent } from '@design/themed-image/components/themed-image/themed-image.component';

@Component({
  selector: 'itc-launcher-content',
  templateUrl: 'launcher-content.component.html',
  styleUrl: 'launcher-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, LauncherItemComponent, SpinnerComponent, ThemedImageComponent],
})
export class LauncherContentComponent implements AfterViewInit {
  private readonly launcherModulesFacade = inject(LauncherModulesFacade);

  readonly launcherContent = viewChild.required<ElementRef<HTMLElement>>('content');
  readonly launcherHeight = signal<string>('');
  readonly loading = this.launcherModulesFacade.loading;
  readonly modules = this.launcherModulesFacade.modules;
  readonly knowledgeBaseLink = 'https://help.one.kaseya.com/help/Default.htm#cshid=enable-login-with-k1';
  readonly closeLauncher = output<void>();

  ngAfterViewInit(): void {
    this.launcherHeight.set(`calc(100vh - ${this.launcherContent().nativeElement.getBoundingClientRect().top}px)`);
  }
}
